"use strict";function e(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var t=e(require("styled-components")).default.li`
    border-radius: 4px;
    box-shadow: ${({theme:e})=>e.shadows.mid};
    display: grid;
    grid-template-columns: 75px 1fr;
    grid-column-gap: 12px;
    padding: 11px 12px;
    align-items: center;

    @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
        grid-template-columns: 108px 1fr;
        grid-column-gap: 18px;
        padding: 12px 14px;
    }

    picture {
        width: 75px;
        height: 75px;
        position: relative;

        @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
            width: 108px;
            height: 108px;
        }

        img {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            object-fit: cover;
        }
    }

    .content {
        display: grid;
        grid-row-gap: 0;
        grid-auto-rows: min-content;

        p {
            margin: 0;

            &.type-caption-short {
                color: ${({theme:e})=>e.colors.grey[700]};
            }
        }
    }
`;module.exports=t;
//# sourceMappingURL=styles.js.map
